import createAxiosInstance from '@/utils/requset'

const apiInstances = {
    api1: createAxiosInstance('api1'),
    api2: createAxiosInstance('api2'),
};

//查询用户信息
export function getUserInfo(parameter) {
    return apiInstances.api1({
        url: `/v1/userInfo/get`,
        method: 'get',
        params: parameter
    })
}

//原密码修改密码 
export function changeOldPassWd(data) {
    return apiInstances.api1({
        url: `/v1/passwd/setByPwd`,
        method: 'post',
        params: data
    })
}

//验证用户密码
export function checkPwd(parameter) {
    return apiInstances.api1({
        url: `/v1/user/checkPwd`,
        method: 'get',
        params: parameter
    })
}

//绑定手机号
export function bindPhone(data) {
    return apiInstances.api1({
        url: `/v1/u_center/bind_phone`,
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//发送短信验证当前用户绑定的手机号
export function checkPhone(data) {
    return apiInstances.api1({
        url: `/v1/u_center/check_user_phone`,
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//检测是否验证过密码
export function isCheckPwd(parameter) {
    return apiInstances.api1({
        url: `/v1/user/checkIsSetPwd`,
        method: 'get',
        params: parameter
    })
}

//检查用户名是否存在
export function checkNickName(parameter) {
    return apiInstances.api1({
        url: '/v1/user/checkNickName',
        method: 'get',
        params: parameter
    })
}

//修改用户名
export function changeName(data) {
    return apiInstances.api1({
        url: '/v1/u_center/setting/modify_name',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//我的粉丝列表
export function getFansList(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/focus/fans_list',
        method: 'get',
        params: parameter
    })
}

//添加关注
export function getFocusAdd(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/focus/add',
        method: 'get',
        params: parameter
    })
}

//取消关注
export function getFocusDel(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/focus/del',
        method: 'get',
        params: parameter
    })
}

//我的关注列表
export function getFocusList(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/focus/focus_list',
        method: 'get',
        params: parameter
    })
}

//检查邮箱是否存在
export function checkEmail(parameter) {
    return apiInstances.api1({
        url: '/v1/user/checkEmail',
        method: 'get',
        params: parameter
    })
}

//发送邮件
export function sendEmail(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/setting/send_email',
        method: 'get',
        params: parameter
    })
}

//绑定邮箱
export function bindEmail(data) {
    return apiInstances.api1({
        url: '/v1/u_center/bind_email',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//通过邮件验证码验证绑定邮箱
export function checkEmailCode(data) {
    return apiInstances.api1({
        url: '/v1/u_center/check_user_email',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//通过邮件验证码修改密码
export function setByEmail(data) {
    return apiInstances.api1({
        url: '/v1/passwd/setByEmail',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//获取个人资料
export function getMyInfo(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/personal/info/get',
        method: 'get',
        params: parameter
    })
}

//修改个人资料
export function editMyInfo(data) {
    return apiInstances.api1({
        url: '/v1/u_center/personal/info/edit',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//上传头像
export function uploadAvatar(data) {
    return apiInstances.api1({
        url: '/v1/u_center/personal/save_photo',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//保存查询隐私
export function getPrivacy(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/personal/privacy',
        method: 'get',
        params: parameter
    })
}

//首页
export function getCenterIndex(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/index',
        method: 'get',
        params: parameter
    })
}

//用户等级详情
export function getLevel(parameter) {
    return apiInstances.api1({
        url: '/v1/u_center/user_level/info',
        method: 'get',
        params: parameter
    })
}

//任务列表
export function getTaskList(parameter) {
    return apiInstances.api1({
        url: '/v1/task/list',
        method: 'get',
        params: parameter
    })
}

//每日签到
export function sign(data) {
    return apiInstances.api1({
        url: '/v1/task/sign_in',
        method: 'post',
        data: data,
    })
}

//领取任务奖励
export function getReward(parameter) {
    return apiInstances.api1({
        url: '/v1/task/get_reward',
        method: 'get',
        params: parameter
    })
}

//明细记录
export function getRecord(parameter) {
    return apiInstances.api1({
        url: '/v1/task/currency_list',
        method: 'get',
        params: parameter
    })
}

//检测是否可以修改昵称
export function checkChangeName(data) {
    return apiInstances.api1({
        url: '/v1/u_center/setting/check_can_modify_name',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}